/** GitHub Profile Card - v2.0.1 **/
/**
 * Github widget styles
 * ------------------------------------------------------------------
 */
.gh-profile-card {
    margin: auto;
    width: 280px;
    border-radius: 5px;
    font-size: 16px;
    font-family: Helvetica;
    background: #fafafa;
    border-width: 1px 1px 2px;
    border-style: solid;
    border-color: #ddd;
    overflow: hidden;
    a {
        text-decoration: none;
        color: #444;
        &:hover {
            color: #4183c4;
        }
    }
    & > header {
        background: #fff;
        overflow: hidden;
        padding: 15px 10px;
        padding-bottom: 0;
    }
}
.profile-name {
    display: block;
    font-size: 1.2em;
    font-weight: bold;
    color: #222;
}

.profile-languages {
    position: relative;
    clear: both;
    margin: 0 -10px;
    padding: 10px;
    border-top: 1px solid #dedede;
    font-size: 0.8em;

    &::before {
        position: absolute;
        top: -0.7em;
        background: #fff;
        padding-right: 5px;
        content: 'Top languages';
        font-style: italic;
        color: #555;
    }
    & > li {
        display: inline-block;
        color: #444;
        font-weight: bold;
        margin-left: 10px;

        &::after {
            content: '\2022';
            margin-left: 10px;
            color: #999;
        }
        &:last-child::after {
            content: '';
        }
    }
}

.profile-follow {
    font-size: 0.8em;
    color: #333;
    padding: 0 10px;
    line-height: 1.5em;
    white-space: nowrap;
    border: 1px solid #d5d5d5;
    border-radius: 3px;
    font-weight: bold;
    background: linear-gradient(#fafafa, #eaeaea);
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.9);
    user-select: none;

    &:hover {
        color: inherit;
        background: linear-gradient(#eee, #ddd);
    }
}
.profile-followers {
    position: relative;
    background: #fff;
    margin-left: 8px;
    padding: 0 5px;
    color: #444;
    font-size: 0.8em;
    border: 1px solid;
    border-color: #bbb;

    &::before {
        content: '';
        position: absolute;
        width: 5px;
        height: 5px;
        left: -4px;
        top: 30%;
        background: inherit;
        border-left: 1px solid;
        border-top: 1px solid;
        border-color: inherit;
        transform: rotate(-45deg);
    }
}
.profile-avatar {
    width: 64px;
    height: 64px;
    margin: 0 10px 15px 0;
    margin-left: 0;
    border-radius: 5px;
    box-shadow: 0 0 2px 0 #ddd;
}

.repos-header {
    font-weight: bold;
    background: linear-gradient(#fafafa, #eaeaea);
    border: solid #d5d5d5;
    border-width: 1px 0;
    color: #555;
    font-size: 0.8em;
    padding: 5px 10px;
}
.profile-repos {
    display: block;
    padding: 7px 10px;
    font-size: 0.9em;
    border-top: 1px solid #ddd;
    &:first-of-type {
        border: none;
    }
}
.repos-name {
    max-width: 280px;
    font-weight: bold;
    text-overflow: ellipsis;
}
.repos-updated {
    font-size: 0.75em;
    font-style: italic;
    color: #777;
}
.repos-star {
    font-size: 0.9em;
    color: #888;
    &::after {
        content: '\a0\2605';
        font-size: 1.1em;
        font-weight: bold;
    }
}
